module.exports = __webpack_public_path__ + "static/media/pexels-sevenstorm-juhaszimrus-1604991.94a78b2e.jpg";